import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReauth } from '../../../common/redux/api/fetchBaseQueryWithReauth'
import baseApiUrl from '../../../lib/baseApiUrl'
import { ChargePointImport } from '../../../common/redux/api/web-api'

export const chargePointApi = createApi({
    reducerPath: 'chargePointsApi',
    baseQuery: (args, api, extraOptions) => baseQueryWithReauth(args, api, { ...extraOptions, baseUrl: baseApiUrl }),
    endpoints: (builder) => ({
        validateImport: builder.mutation<ChargePointImport[], { companyId: string; importData: string }>({
            query: (args) => {
                return {
                    url: `/companies/${args.companyId}/chargepoints/validateimport`,
                    method: 'POST',
                    body: args.importData,
                    headers: {
                        'content-type': 'text/plain; charset=UTF-8',
                    },
                }
            },
        }),
        validateImportChargePointsinLBGroup: builder.mutation<ChargePointImport[], { id: string; importData: string }>({
            query: (args) => {
                return {
                    url: `/loadbalancergroups/${args.id}/chargepoints/validateimport`,
                    method: 'POST',
                    body: args.importData,
                    headers: {
                        'content-type': 'text/plain; charset=UTF-8',
                    },
                }
            },
        }),
        importChargepoints: builder.mutation<void, { companyId: string; importData: ChargePointImport[] }>({
            query: (args) => {
                return {
                    url: `/companies/${args.companyId}/chargepoints/import`,
                    method: 'POST',
                    body: args.importData,
                    headers: {
                        'content-type': 'application/json',
                    },
                }
            },
        }),
    }),
})

export const {
    useValidateImportMutation,
    useImportChargepointsMutation,
    useValidateImportChargePointsinLBGroupMutation,
} = chargePointApi
